import { defineComponent } from "vue";
export default defineComponent({
  name: "Notice",
  setup: function setup() {
    return {
      notice: '开放API-2.0正式上线，原<a href="/v1">API-1.0版本Spring-Boot SSM</a>项目已成为历史，此次更新后，增加访问频率限制，防止1.0版本出现的恶意攻击导致服务异常问题，数据更新陆续进行中...'
    };
  }
});